// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One conversation. Root: .chat-thread (inside .chat-page). */
.chat-thread {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background: var(--ds-bg);
}

.chat-thread__header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-height: 60px;
  padding: var(--ds-space-2) var(--ds-space-3);
  border-bottom: 1px solid var(--ds-border-soft);
  background: var(--ds-surface);
}

[dir="rtl"] .chat-thread .chat-thread__back .anticon {
  transform: scaleX(-1);
}

.chat-thread__avatar {
  flex-shrink: 0;
}

.chat-thread__who {
  flex: 1 1 auto;
  min-width: 0;
}

.chat-thread__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  color: var(--ds-text);
}

.chat-thread__status {
  font-size: 0.8125rem;
  color: var(--chat-online);
}

.chat-thread__messages {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: var(--ds-space-3);
}

.chat-thread__notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3);
  text-align: center;
}

.chat-thread .chat-thread__encrypted .ant-bubble-content {
  max-width: min(520px, 100%);
  background: var(--ds-surface-muted);
  color: var(--ds-text-2);
  font-size: 0.8125rem;
}

.chat-thread .chat-thread__date .ant-bubble-content {
  background: var(--ds-brand-tint);
  color: var(--ds-text-2);
  font-size: 0.75rem;
}

.chat-thread .chat-thread__bubble {
  margin-bottom: var(--ds-space-2);
}

.chat-thread .chat-thread__bubble .ant-bubble-content {
  max-width: min(560px, 80vw);
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.chat-thread .chat-thread__avatar--me {
  background: var(--ds-brand);
  color: var(--ds-surface);
}

.chat-thread .chat-thread__avatar--them {
  background: var(--ds-brand-dark);
  color: var(--ds-surface);
}

/* Composer stays at the bottom of the thread; on phones it pads itself above the
   home indicator (see .chat-page--compact). */
.chat-thread__composer {
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  gap: var(--ds-space-2);
  padding: var(--ds-space-2) var(--ds-space-3);
  padding-bottom: calc(var(--ds-space-2) + var(--chat-composer-bottom, 0px));
  border-top: 1px solid var(--ds-border-soft);
  background: var(--ds-surface);
}

.chat-thread__composer .ant-input {
  flex: 1 1 auto;
  min-width: 0;
}

.chat-thread .chat-thread__composer .file-upload {
  padding: 0;
}

.chat-thread__send {
  flex-shrink: 0;
}

@media (max-width: 575.98px) {
  .chat-thread__send-label {
    display: none;
  }
}

/* Attachments rendered by renderFile() */
.chat-thread .messageFile {
  max-width: min(310px, 100%);
  max-height: 341px;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
  text-align: center;
}

.chat-thread .messageFileLink {
  display: block;
  max-width: 100%;
  width: max-content;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
  color: var(--ds-brand-strong);
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Chats/ChatWindow/ChatWindow.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;EAC5C,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;8CAC8C;AAC9C;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;EAC5C,0EAA0E;EAC1E,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,uBAAuB;AACzB","sourcesContent":["/* One conversation. Root: .chat-thread (inside .chat-page). */\n.chat-thread {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  background: var(--ds-bg);\n}\n\n.chat-thread__header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-height: 60px;\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border-bottom: 1px solid var(--ds-border-soft);\n  background: var(--ds-surface);\n}\n\n[dir=\"rtl\"] .chat-thread .chat-thread__back .anticon {\n  transform: scaleX(-1);\n}\n\n.chat-thread__avatar {\n  flex-shrink: 0;\n}\n\n.chat-thread__who {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.chat-thread__name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n  color: var(--ds-text);\n}\n\n.chat-thread__status {\n  font-size: 0.8125rem;\n  color: var(--chat-online);\n}\n\n.chat-thread__messages {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: var(--ds-space-3);\n}\n\n.chat-thread__notice {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3);\n  text-align: center;\n}\n\n.chat-thread .chat-thread__encrypted .ant-bubble-content {\n  max-width: min(520px, 100%);\n  background: var(--ds-surface-muted);\n  color: var(--ds-text-2);\n  font-size: 0.8125rem;\n}\n\n.chat-thread .chat-thread__date .ant-bubble-content {\n  background: var(--ds-brand-tint);\n  color: var(--ds-text-2);\n  font-size: 0.75rem;\n}\n\n.chat-thread .chat-thread__bubble {\n  margin-bottom: var(--ds-space-2);\n}\n\n.chat-thread .chat-thread__bubble .ant-bubble-content {\n  max-width: min(560px, 80vw);\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n\n.chat-thread .chat-thread__avatar--me {\n  background: var(--ds-brand);\n  color: var(--ds-surface);\n}\n\n.chat-thread .chat-thread__avatar--them {\n  background: var(--ds-brand-dark);\n  color: var(--ds-surface);\n}\n\n/* Composer stays at the bottom of the thread; on phones it pads itself above the\n   home indicator (see .chat-page--compact). */\n.chat-thread__composer {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  align-items: flex-end;\n  gap: var(--ds-space-2);\n  padding: var(--ds-space-2) var(--ds-space-3);\n  padding-bottom: calc(var(--ds-space-2) + var(--chat-composer-bottom, 0px));\n  border-top: 1px solid var(--ds-border-soft);\n  background: var(--ds-surface);\n}\n\n.chat-thread__composer .ant-input {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.chat-thread .chat-thread__composer .file-upload {\n  padding: 0;\n}\n\n.chat-thread__send {\n  flex-shrink: 0;\n}\n\n@media (max-width: 575.98px) {\n  .chat-thread__send-label {\n    display: none;\n  }\n}\n\n/* Attachments rendered by renderFile() */\n.chat-thread .messageFile {\n  max-width: min(310px, 100%);\n  max-height: 341px;\n  margin-bottom: 10px;\n  padding: 10px;\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  text-align: center;\n}\n\n.chat-thread .messageFileLink {\n  display: block;\n  max-width: 100%;\n  width: max-content;\n  margin-bottom: 10px;\n  padding: 10px;\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  color: var(--ds-brand-strong);\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
